import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { VisibilityPicker } from "./VisibilityIcon";
import { NameChips } from "./NameChips";

export const NewAlbumDialog = ({ open, onClose, onCreated, itemIds, defaultSpace = "private" }) => {
  const [name, setName] = useState("");
  const [space, setSpace] = useState(defaultSpace);
  useEffect(() => { if (open) { setName(""); setSpace(defaultSpace); } }, [open, defaultSpace]);
  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      const { data } = await api.post("/albums", { name, space });
      onClose();
      onCreated?.(data);
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#f4f3f0]" data-testid="new-album-dialog">
        <DialogHeader>
          <DialogTitle className="serif text-2xl">New album</DialogTitle>
          <DialogDescription>Who can see it?</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <input className="login-input !mb-0" placeholder="Album name" autoFocus value={name} onChange={(e) => setName(e.target.value)} data-testid="new-album-dialog-name" />
          {open && <NameChips itemIds={itemIds} onPick={setName} testid="new-album-name-chips" />}
          <VisibilityPicker value={space} onChange={setSpace} testid="new-album-visibility" />
          <button className="btn-ink" data-testid="new-album-dialog-create">Create album</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
